export const STAT_CAMPAIGN_DETAIL_REQUEST =
  'stats/STAT_CAMPAIGN_DETAIL_REQUEST';
export const STAT_CAMPAIGN_DETAIL_FAILURE =
  'stats/STAT_CAMPAIGN_DETAIL_FAILURE';
export const STAT_CAMPAIGN_DETAIL_SUCCESS =
  'stats/STAT_CAMPAIGN_DETAIL_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/Statistics/constants.js